import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useI18n } from "@/locales/client";
import { useTRPC } from "@/trpc/client";

export const useCancelSubscription = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const t = useI18n();

  return useMutation(
    trpc.stripe.cancelSubscription.mutationOptions({
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: trpc.users.getUserPlan.queryKey(),
        });
        queryClient.invalidateQueries({
          queryKey: trpc.users.getPlanLimit.queryKey(),
        });
        toast.success(t("cancellation.toast.cancelSuccess"), {
          description: t("cancellation.toast.cancelSuccessDescription"),
        });
      },
      onError: (error) => {
        console.error("Failed to cancel subscription", error);
        toast.error(t("cancellation.toast.cancelError"), {
          description: t("cancellation.toast.cancelErrorDescription"),
        });
      },
    }),
  );
};
